import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import CancelButton from "../../Components/CommonComponent/Button/CancelButton";
import SaveButton from "../../Components/CommonComponent/Button/SaveButton";
import api from "../../services/api";

function ChangePasswordForm({ manager, onClose }) {
  const {t} = useTranslation();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [errors, setErrors] = useState({
    old: "",
    new: "",
    confirm: "",
  });

  const handleSave = async () => {
    const newErrors = { old: "", new: "", confirm: "" };
    let isValid = true;

    if (!oldPassword) {
      newErrors.old = "Old password is required";
      isValid = false;
    }
    if (!newPassword) {
      newErrors.new = "New password is required";
      isValid = false;
    } else if (newPassword.length < 1) {
      newErrors.new = "New password must be at least 1 characters";
      isValid = false;
    }
    if (!confirmPassword) {
      newErrors.confirm = "Confirm password is required";
      isValid = false;
    } else if (newPassword !== confirmPassword) {
      newErrors.confirm = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    if (!isValid) return;

    setLoading(true);
    try {
      const res = await api.post(
        `manager/change-password?id=${manager.id}`,
        {
          old_password: oldPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }
      );

      if (res.data.success) {
        toast.success(res.data.message || "Password changed successfully");
        onClose();
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setErrors({ old: "", new: "", confirm: "" });
      } else {
        toast.error(res.data.message || "Failed to change password");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="space-y-4 text-sm">
        {/* Old Password */}
        <div>
          <label className="font-medium">{t('oldPassword')} </label>
          <div className="relative">
            <input
              type={showOld ? "text" : "password"}
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Enter old password"
              className={`border p-2 rounded w-full outline-none ${
                errors.old ? "border-red-500" : ""
              }`}
            />
            <span
              onClick={() => setShowOld(!showOld)}
              className="absolute right-3 top-3 cursor-pointer text-gray-600"
            >
              {showOld ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {errors.old && (
            <p className="text-red-500 text-sm mt-1">{errors.old}</p>
          )}
        </div>

        {/* New Password */}
        <div>
          <label className="font-medium">{t('newPassword')} </label>
          <div className="relative">
            <input
              type={showNew ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              className={`border p-2 rounded w-full outline-none ${
                errors.new ? "border-red-500" : ""
              }`}
            />
            <span
              onClick={() => setShowNew(!showNew)}
              className="absolute right-3 top-3 cursor-pointer text-gray-600"
            >
              {showNew ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {errors.new && (
            <p className="text-red-500 text-sm mt-1">{errors.new}</p>
          )}
        </div>

        {/* Confirm Password */}
        <div>
          <label className="font-medium">{t('confirmPassword')} </label>
          <div className="relative ">
            <input
              type={showConfirm ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              className={`border p-2 rounded w-full outline-none ${
                errors.confirm ? "border-red-500" : ""
              }`}
            />
            <span
              onClick={() => setShowConfirm(!showConfirm)}
              className="absolute right-3 top-3 cursor-pointer text-gray-600"
            >
              {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {errors.confirm && (
            <p className="text-red-500 text-sm mt-1">{errors.confirm}</p>
          )}
        </div>
      </div>

      {/* Forgot Password Section */}
      <div className="mt-2  flex justify-end">
        <button
          onClick={() => toast.success("Password reset process started")}
          className="text-sm font-medium text-theme-headerBg hover:underline"
        >
          {t('forgetPassword')} 
        </button>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end gap-2 mt-2">
 
        <CancelButton onClick={onClose} text={t('cancel')}  />
    
        <SaveButton onClick={handleSave} text={t('save')} disabled={loading}  />
      </div>
    </>
  );
}

export default ChangePasswordForm;
